module.exports = __webpack_public_path__ + "img/edit.056065eb.svg";